export default {
  app:{
  provider: 'Provider',
  searchGames: 'Search Games...',
  username: 'Username',
  },
  nav: {
      home: 'Home',
      games: 'Games',
      profile: 'Profile'
    },
  auth: {
  login: 'Login',
  logout: 'Logout',
  register: 'Register',
  usernamePlaceholder: 'USERNAME',
  passwordPlaceholder: 'PASSWORD',
  togglePassword: 'Toggle password visibility',
  forgotPassword: 'Forgot password',
 // Auth section:
namePlaceholder: 'Full name',
emailPlaceholder: 'Email',
confirmPasswordPlaceholder: 'Confirm password',
acceptTerms: 'I accept the terms and conditions',
alreadyHaveAccount: 'have an account? Log in',
affiliateCodePlaceholder: 'Affiliate code (optional)',
affiliateCode: 'Affiliate Code',
adultConfirmation: 'Adult Confirmation',
registrationSuccessful: 'Registration successful! You can now login with your credentials.',  
  errors: {
    // Backend error codes
    user_not_found: 'User not found',
    active_session: 'Active session detected',
    invalid_password: 'Invalid password',
    account_banned: 'Account banned',
    invalid_credentials: 'Invalid credentials',
    // Frontend validations
    emptyUsername: 'Username field cannot be empty',
    emptyPassword: 'Password field cannot be empty',
    // General errors
    connectionError: 'Connection error',
    serverError: 'Server error, please try again later',
    // Registration error:
emptyName: 'Full name is required',
emptyEmail: 'Email is required',
passwordMismatch: 'Passwords do not match',
termsRequired: 'You must accept the terms and conditions',
registerFailed: 'Failed to register the account. Please try again.',
emailInvalid: 'Invalid email',
emailTaken: 'Email is already in use',
usernameTaken: 'Username is already in use',
usernameInvalid: 'Username must be at least 3 characters long',
passwordWeak: 'Password must be at least 8 characters long',
passwordInvalid: 'Password must be at least 8 characters long',
passwordRequired: 'Password is required',
usernameRequired: 'Username is required',
emailRequired: 'Email is required',
loginRequired: 'You must log in to continue',
adultConfirmationRequired: 'You must confirm you are over 18 years old',

  }
},
    loading: {
    title: 'Loading',
    resources: 'Resources',
    credentials: 'Credentials',
    games: 'Games',
    jackpots: 'Jackpots',
    balances: 'Balances'
  },
   account: {
    title: 'Account',
    balance: 'Balance',
    credit: 'Credit',
    bonus: 'Bonus',
    terminal: 'Terminal',
    id: 'ID',
    logout: 'Logout'
  },
  pagination: {
    loadMoreGames : "Load more games",
    noMoreGames : "No more games to load",
    show: "Show",
    of : "of",
    games : "games",
  },
  "header": {
    "return_lobby": "Return Lobby"
  },
  "cashback": {
    "notify_bonus_message": "You have received a cashback bonus of:",
  },
  footer:{
    contactUs: 'Contact Us',
    followUs: 'Follow Us',
    aboutUs: 'About Us',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    responsibleGaming: 'Responsible Gaming',
    affiliates: 'Affiliates',
    faq: 'FAQ',
    blog: 'Blog',
    mobileApp: 'Mobile App',
    promotions: 'Promotions',
    support: 'Support',
    paymentMethods: 'Payment Methods',
    gameProviders: 'Game Providers',
    socialMedia: 'Social Media',
    allRightsReserved: 'All rights reserved',

  },
  report:{
    tittle: 'My Reports',
    user: 'user',
    transactions: 'Transactions',
    from: 'from',
    to: 'to',
    type: 'Type',
    all: 'All',
    deposits: 'Deposits',
    withdrawals: 'Withdrawals',
    total_deposits: 'Total Deposits',
    total_withdrawals: 'Total Withdrawals',
    total_net: 'Total Net',
    date: 'Date',
    amount: 'Amount',
    description: 'Description',
    page:'Page',
    of: 'of',
    previous: 'previous',
    next:'Next',
    loading_transactions: 'Loading Transactions...',
    no_transactions_found_for_this_period:'No Transactions Found for this Period',
    games:'Games',
    game:'Game',
    provider:'Provider',
    total_bet:'total bet',
    total_win:'Total Win',
    net_result:'Net Win',
    average_rtp:'RTP',
    no_game_data_found:'No Games Data Found',
    try_different_date_range:'Try Different Date Range',
    bonuses:'Bonuses',
    status:'Status',
    all_statuses: 'All',
    collected: 'Collected',
    pending:'Pending',
    cancelled:'cancelled',
    no_bonus_data_found:' No Bonus Data Found',
    parent_id:'Parent Id',
    player_id:'Player_Id',
    balance_before:'Before',
    balance_after:'After',
    bet_amount:'Bet',
    won_loss:'Result',
    bonus_type:'Bonus',
    game_name:'Game',
    bonus_active:'Active',
    bonus_collected: 'Bonus Collected',
    bonus_cancelled: 'Bonus Cancelled',
    loading_game_history:'Loading Game History',
    bonus_by_status:'Bonus By Status',
    total_cashback:'Total cashback',
    total_jackpot:'Total Jackpot',
    total_bonus:'Total Bonus',
    cashback_history:'cashback History',
    bonus_amount:'Bonus Amount',
    bonus_cashback: "Bonus (Cashback)",
    bonus_pending: "Pending Bonus",
    bonus_jackpot: "Bonus (Jackpot)",
    

    


    },
  "errors": {
     "need_balance_to_launch": "You need balance to play"
  },
  "common": {
    "close": "CLOSE"
  }

  }